import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import axios from 'axios';
import { getUserId,aPIURL } from '../utils/common';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddSale = () => {
  
  const [post, setPost] = useState([]);
  const API_URL=aPIURL();
   const [number, setNumber] = useState(1); 
   const [postPerPage] = useState(10);
   const [showAddSaleDevice, setShowAddSaleDevice]= useState(false);
   const [inputs, setInputs] = useState({});
   const [customerData, setCustomerData]= useState([]);
   const [custID, setCustID]=useState(0);
   const [subscriptionData,setSubscriptionData]= useState([]);
   const [saleDeviceData,setSaleDeviceData]= useState([]);
   let [saleFDeviceData,setSaleFDeviceData]= useState([]);
   const [saleSubscriptionTypeID, setSaleSubscriptionTypeID]=useState(0);
   const [dModel, setDModel]=useState("GPS-V5");
   const [devicestock, setDevicestock]=useState(0);
   const [cGstPer, setCGstPer]=useState(0);
   const [sGstPer, setSGstPer]=useState(0);
   const [iGstPer, setIGstPer]=useState(0);
   const [cGstVal, setCGstVal]=useState(0.00);
   const [sGstVal, setSGstVal]=useState(0.00);
   const [iGstVal, setIGstVal]=useState(0.00);
   let [quantity, setQuantity]=useState(0);
   let [discountVal, setDiscountVal]=useState(0.00);
   let [insChargeVal, setInsChargeVal]=useState(0.00);
   let [gTotalVal, setGTotalVal]=useState(0.00);
   let [totAmount,setTotAmount]=useState(0.00);
   let [payableAmount,setPayableAmount]=useState(0.00);
   const [currencyType,setCurrencyType]=useState("INR");  
   const [termType,setTermType]=useState(0);
   const [cDisplay, setCDisplay]= useState('none');
   const d = new Date();
   let [due_Date,setDue_Date]= useState("");
   let DeviceIEMI_Number=0;
   let devID=0;
   let DeviceSIM_Number=0;
   let perdevCost=0; 
   let chkID=0;
   let checkStatus=false;
   const [btnDisplay, setBtnDisplay]= useState('none');
   let [min_Date,setMin_Date]= useState("");
   let [max_Date,setMax_Date]= useState("");   
   let saleDeviceJson= "[";
   let newduedate="";
   let [sImeiNo , setSImeiNo]= useState('');   
   let [sSimNo , setSSimNo]= useState('');  

   useEffect(() => {
    
    const Type_ID=0;
    getSevenDaysAgoDate();
    const curls=API_URL+`GpsCustomerAllList/?TypeID=${Type_ID}`; 
    
    axios.post(curls).then(response => {
        
    const updatedCustomerList = response.data.data.filter((curElem) => {        
        return curElem.status === "Active";
        });
                setCustomerData(updatedCustomerList);     
                  
        }).catch(function(error) { console.log(error.message); });  

        axios.get(API_URL+`Subscribe/1`).then(response => {
        setSubscriptionData(response.data.data);    
        }).catch(function(error) { console.log(error.message); }); 
        
        setDevicestock(0);
        
        axios.get(API_URL+`DeviceStock/?Account_ID=0`).then(response => {
             setDevicestock(response.data.data[0].pendingStock);    
        }).catch(function(error) { console.log(error.message); }); 
        inputs.deviceCost=perdevCost;  
    }, []);
        
    let rc=1;
    

const ChangePage = ({ selected }) => {
        
        setNumber(selected+1);
  };

const getSevenDaysAgoDate = () => 
 {
    const date = new Date();
    date.setDate(date.getDate() - 7);
    setMin_Date(date.toISOString().split('T')[0]);
    const mdate = new Date();
    mdate.setDate(mdate.getDate());
    setMax_Date(mdate.toISOString().split('T')[0]);

    //set today date as default date starts
    var now = new Date();
    var month = (now.getMonth() + 1);               
    var day = now.getDate();
    if (month < 10) 
    month = "0" + month;
    if (day < 10) 
    day = "0" + day;
    var today = now.getFullYear() + '-' + month + '-' + day;
    inputs.invoicedate = today;
    //set today date as default date ends    
 };

const showAddSaleDeviceDetails=()=>
{
    setShowAddSaleDevice(true);
    axios.post(API_URL + 'GpsSaleCustomerList/').then(response => {
            setCustomerData(response.data.data);                             

    }).catch(function(error) { console.log(error.message); });  

    axios.get(API_URL+'Subscribe').then(response => {       
       
    setSubscriptionData(response.data.data);    

    }).catch(function(error) { console.log(error.message); });  
}


const ChangeCustomerID = (e) => {

       setCustID(e.target.value);    
}
const ChangeSubscriptionType=(e)=>
{
      let durationID= 0;
      durationID=e.target.value;
      setSaleSubscriptionTypeID(durationID);  
      inputs.deviceCost=perdevCost*durationID;
      
}
const ChangeDModel=(e)=>
{
       setDModel(e.target.value);   
}
const ChangeCurrency=(e)=>
{
    setCurrencyType(e.target.value);    
}

const ChangeTerms=(e)=>
{
     let dterms=0;
     dterms=e.target.value;
     setTermType(dterms);
     
    
    if(e.target.value==7)
    {
        d.setDate(d.getDate() + 7);
    }
   else if(e.target.value==15)
    {
        d.setDate(d.getDate() + 15);
    }
   else if(e.target.value==30)
    {
        d.setDate(d.getDate() + 30);
    }
    else if(e.target.value==60)
    {
        d.setDate(d.getDate() + 60);
    }
    else
    {
        d.setDate(d.getDate());
    }
    let ddate=d.getDate()
    let dmonth=d.getMonth()+ 1;
    let dyear=d.getFullYear();
    if(dmonth<10)
    {
      dmonth='0'+dmonth;
    }
    newduedate=  ddate + "-" + dmonth + "-" + dyear;
    setDue_Date(newduedate);    
}

const ChangeCGST=(e)=>
{
    setCGstPer(e.target.value);     
    setCGstVal(parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00));
    setGTotalVal(parseFloat(payableAmount,2) + (parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00)) +  parseFloat(sGstVal,2) + parseFloat(iGstVal,2));
    
}
const ChangeSGST=(e)=>
{
    
    setSGstPer(e.target.value);     
    setSGstVal(parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00));
    setGTotalVal(parseFloat(payableAmount,2) + (parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00)) + parseFloat(cGstVal,2) +  parseFloat(iGstVal,2));
}
const ChangeIGST=(e)=>
{
    setIGstPer(e.target.value);     
    setIGstVal(parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00));
    setGTotalVal(parseFloat(payableAmount,2) + (parseFloat(payableAmount,2)*(parseFloat(e.target.value)/100.00)) + parseFloat(cGstVal,2)+ parseFloat(sGstVal,2));
}

const changeVHandler = (event) => {
 
            if(event.target.name==='ddiscount')
            {
                setCGstPer(0);
                setSGstPer(0);
                setIGstPer(0);
                setCGstVal(0.00);
                setSGstVal(0.00);
                setIGstVal(0.00);
                setDiscountVal(event.target.value);
                setGTotalVal((parseFloat(totAmount,2)  - event.target.value) + parseFloat(insChargeVal,2) + parseFloat(cGstVal,2)+ parseFloat(sGstVal,2)+ parseFloat(iGstVal,2)); 
                setPayableAmount((parseFloat(totAmount,2)  - event.target.value) + parseFloat(insChargeVal,2));   

            }
            else if(event.target.name==='installationcharge')
            {
                setSGstPer(0);
                setCGstPer(0);
                setIGstPer(0);
                setCGstVal(0.00);
                setSGstVal(0.00);
                setIGstVal(0.00);
                setInsChargeVal(event.target.value);
                setGTotalVal((parseFloat(totAmount,2) - parseFloat(discountVal,2)) + parseFloat(event.target.value)+ parseFloat(cGstVal,2)+ parseFloat(sGstVal,2)+ parseFloat(iGstVal,2));
                setPayableAmount((parseFloat(totAmount,2)  - parseFloat(discountVal,2)) + parseFloat(event.target.value,2));
            }
            else
            {
                const name = event.target.name;
                const value = event.target.value;
                setInputs(values => ({...values, [name]: value}))
            }
}
const SImeiNochangeHandler=(e)=>
{
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value))
        {
             setSImeiNo(e.target.value)
        }
        else
        {
           setSImeiNo('');
        }
}

const SSimNochangeHandler=(e)=>
{
     const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value))
        {
             setSSimNo(e.target.value)
        }
        else
        {
           setSSimNo('');
        }
}
const SaleInsert=()=>
{
        if(quantity===0)
        {
              toast.error('Please Select Device from List.')
              return
        }
        else
        {
            const params = JSON.stringify({
            "InvoiceID":0,
            "customerID": parseInt(custID),
            "invoiceDate": inputs.invoicedate,
            "model": dModel,
            "subscriptionDuration": parseInt(saleSubscriptionTypeID),
            "currency": currencyType,
            "terms": parseInt(termType),
            "dueDate": due_Date,
            "price": parseInt(inputs.deviceCost),
            "stock": devicestock,
            "quantity": quantity.toString(),
            "totalAmount": totAmount.toString() ,
            "discount": discountVal.toString(),
            "installationCharge": insChargeVal.toString(),
            "cgstPer": parseInt(cGstPer),
            "cgstVal": cGstVal.toFixed(2),
            "sgstPer": parseInt(sGstPer),
            "sgstVal": sGstVal.toFixed(2),
            "igstPer": parseInt(iGstPer),
            "igstVal": iGstVal.toFixed(2),
            "grandTotal": gTotalVal.toFixed(2),
            "invoiceType": "New Device Sale"               
        });
          
         axios.post(API_URL+'GPSDeviceSaleInsert', params, {
           
            "headers": 
             {
                 "content-type": "application/json",    
             },
             })
             .then(function (response) 
             {
                     if(!response.data.validStatus)
                     {
                                toast.error(response.data.message);                                                                 
                     }
                     else
                     {
                           ReadValue(response.data.id);
                           setBtnDisplay('none'); 
                           toast.success(response.data.message);                                                       
                   }      
             })
             .catch(function (error) 
             {
                   toast.error("Some Error occured while saving sale device record,Please Provide Valid Inputs.");                  
                   console.log(error.message);    
             });
             //GPSDevice Sale Insert ends   
}
}

const  ReadValue=(ResID)=>
{
       
    var table = document.getElementById("example"),rIndex,cIndex;    
    
    var i = 0;var col=0;

        for(var j=1;j<table.rows.length;j++)
        {
           
            for(var col=0;col<table.rows[0].cells.length;col++)
            { 
                if(table.rows[0].cells[col].innerHTML==="Select")
                {
                         DeviceIEMI_Number = document.getElementById("checkbox"+j).value;
                         checkStatus =  document.getElementById("checkbox"+j).checked
                         chkID=table.rows[j].cells[col].innerHTML;                                                                                                         
                } 
                else if(table.rows[0].cells[col].innerHTML==="Device ID")
                {
                        devID=table.rows[j].cells[col].innerHTML;
                                                                
                } 
                else if(table.rows[0].cells[col].innerHTML==="IMEI#")
                {
                         DeviceIEMI_Number=table.rows[j].cells[col].innerHTML;
                                                            
                }
                else if(table.rows[0].cells[col].innerHTML==="SIM#")
                {
                        DeviceSIM_Number = table.rows[j].cells[col].innerHTML;                                               
                }                  
                else
                {

                }       
            }
           if(checkStatus)
           {
            const allotmentparams = JSON.stringify({

                "accountID": parseInt(custID),
                "allotmentID": 0,
                "imeiNumber": DeviceIEMI_Number,
                "allotmentBy": inputs.SaleBy,
                "allotyName": "",
                "deviceID": devID,
                "subscribeID": parseInt(saleSubscriptionTypeID),
                "invoiceID": ResID,
                "rechargeType": "New Device Sale",
                "simNumber": DeviceSIM_Number,
                "price": inputs.deviceCost  
  
            });
            
            axios.post(API_URL+'AllotmentDevice/', allotmentparams, {
    
                "headers": 
                {
                       "content-type": "application/json",    
                },       
           })
             .then(function (response) 
             {                             
                  
             })
             .catch(function (error) 
             {
                    console.log(error.message);    
             });
            }
        }          
       
    }
         
const AddSaleDetails=()=>
{
      if (custID == 0) 
      {
            toast.error('Please Select Customer.')
            return
      }
      else if(inputs.invoicedate==='' || (!inputs.invoicedate))
      {
        toast.error('Please Select Invoice Date.')
        return
      }
      else if(saleSubscriptionTypeID== 0)
      {
            toast.error('Please Select Subscription Duration.')
            return
      }
      else if(inputs.SaleBy==='' || (!inputs.SaleBy))
      {
            toast.error('Sales Person is required.')
            return
      }
      else if(currencyType== "0")
      {
            toast.error('Currency is required.')
            return
      }
      else if(termType== "0")
      {
            toast.error('Payment Terms is required.')
            return
      }
      else if(inputs.deviceCost==='' || inputs.deviceCost==='0' || (!inputs.deviceCost))
      {
            toast.error('Price is required.')
            return
      }
      else if(devicestock== 0)
      {
            toast.error('You donot have any device in stock.')
            return

      }
      else if(devicestock < quantity )
      {
            toast.error('Insufficient Stock.');
            return
      }      
      else
      {
            setCDisplay('block');
            setBtnDisplay('block');              
            let sdurl=API_URL+`DeviceSale/?Account_ID=0&Device_Count=${devicestock}`
            axios.get(sdurl).then(response => {
            //console.log("------------------response.data.data-----------------------------");
            //console.log(response.data.data);
            setSaleDeviceData(response.data.data);  
            setSaleFDeviceData(response.data.data); 
              
            }).catch(function(error) { console.log(error.message); });   
       }      
}
const handleChange = (e) => {

    if(e.target.checked)
     {
            setQuantity(quantity+1);
            setTotAmount(parseFloat(inputs.deviceCost)*parseFloat(quantity+1)*1.00);
            setGTotalVal(parseFloat(inputs.deviceCost)*parseFloat(quantity+1)*1.00);
            setPayableAmount(parseFloat(inputs.deviceCost)*parseFloat(quantity+1)*1.00);    
     }
     else
     {
            setQuantity(quantity-1);
            setTotAmount(parseFloat(inputs.deviceCost)*parseFloat(quantity-1)*1.00);
            setGTotalVal(parseFloat(inputs.deviceCost)*parseFloat(quantity-1)*1.00);
            setPayableAmount(parseFloat(inputs.deviceCost)*parseFloat(quantity-1)*1.00); 
     }
}
const FilterGrid=()=>
{
        if(sImeiNo !='')
        {
                const updatedsaleData1 = saleDeviceData.filter((curElem1) => {  return curElem1.imeiNumber === sImeiNo;   });
                setSaleFDeviceData(updatedsaleData1);
        }
        else if(sSimNo !='')
        { 
                const updatedsaleData2 = saleDeviceData.filter((curElem2) => {  return curElem2.mobileNumber === sSimNo;  });
                setSaleFDeviceData(updatedsaleData2);                
        }  
       else 
       {    
                setSaleFDeviceData(saleDeviceData);           
       }
}
const ResetList=()=>
{
        setSSimNo('');
        setSImeiNo('');
        setSaleFDeviceData(saleDeviceData);
        setQuantity(0);
        setTotAmount(0.00);
        setGTotalVal(0.00);
        setPayableAmount(0.00);    
        
        var table1 = document.getElementById("example"),rIndex,cIndex;    
        var i = 0;var col=0;

        for(var j=1;j<table1.rows.length;j++)
        {
           for(var col=0;col<table1.rows[0].cells.length;col++)
            { 
                if(table1.rows[0].cells[col].innerHTML==="Select")
                {
                      document.getElementById("checkbox"+j).checked= false;                                                                                                                               
                }                 
            }
        }
}

  return (
  <>
            <div className='row'>
                            <div className='col-md-6 col-lg-6 form-group'>
                            Customer <span style={{color:"red"}}>&nbsp;*</span>
                            <select className="form-control"  name="DCustomerID" value={custID} onChange={ChangeCustomerID} >
                            <option>Select Customer</option>
                            {customerData.map((e, key) => {
                            return <option key={key} value={e.accountID}>{e.customerName}</option>;
                            })}
                            </select>
                            </div>
                             <div className='col-md-6 col-lg-3 form-group'>
                            Invoice Date  <span style={{color:"red"}}>&nbsp;*</span>
                            <input name="invoicedate"  type="date" className="form-control"  value={inputs.invoicedate}  min={min_Date} max={max_Date}  onChange={changeVHandler}/>
                            </div>
                            <div className='col-md-6 col-lg-3 form-group'>                            
                            <input name="invoiceno"  type="text" disabled="disabled" style={{ display:"none"}} className="form-control"  value={78787}  onChange={changeVHandler}/>
                            </div>
                           {/*  <div className='col-md-6 col-lg-3 form-group'>
                            Model 
                            <select className="form-control" name="DModel" value={dModel}  onChange={ChangeDModel} >
                            <option value={"GPS-V5"}>GPS-V5</option>               
                            </select>
                            </div>*/}
                            <div className='col-md-6 col-lg-3 form-group'>
                            Subscription Duration  <span style={{color:"red"}}>&nbsp;*</span>
                            <select className="form-control"  name="DSubscriptionType" value={saleSubscriptionTypeID} onChange={ChangeSubscriptionType} >
                             <option value={0}>Select Duration</option>
                            {subscriptionData.map((e, key) => {
                            return <option key={key} value={e.id}>{e.subscribeName}</option>;
                            })}
                            </select>  
                            </div>
                            <div className='col-md-6 col-lg-6 form-group'>
                            Sales Person : <span style={{color:"red"}}>&nbsp;*</span>  
                            <input name="SaleBy"  type="text"   className="form-control"  value={inputs.SaleBy} onChange={changeVHandler}></input>    
                            </div>      <div className='col-md-6 col-lg-2 form-group'></div>                                           
                            <div className='col-md-6 col-lg-2 form-group'>
                            Currency <span style={{color:"red"}}>&nbsp;*</span>
                            <select className="form-control" name="dcurrency" value={currencyType}  style={{ "backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px"}}  onChange={ ChangeCurrency} >
                            <option value={"0"}>Select</option>    
                            <option value={"INR"}>INR-Indian Rupee</option>  
                            <option value={"CAD"}>CAD-Canadian Dollar</option>   
                            <option value={"USD"}>USD-US Dollars</option>           
                            </select> 
                            </div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            Payment Terms <span style={{color:"red"}}>&nbsp;*</span>
                            <select className="form-control" name="dterms"   value={termType} style={{ "backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px"}} onChange={ ChangeTerms }  >
                            <option value={0}>Select Terms</option> 
                            <option value={7}>7 Days</option>    
                            <option value={15}>15 Days</option>  
                            <option value={30}>30 Days</option>   
                            <option value={60}>60 Days</option>           
                            </select> 
                            </div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            Due Date 
                            <br/>
                            <input name="deviceCost"  type="text"  disabled={true} className="form-control"  value={due_Date}  /> 
                            </div>
                            <div className='col-md-6 col-lg-2 form-group'>
                            Price <span style={{color:"red"}}>&nbsp;*</span>
                            <input name="deviceCost"  type="text"  maxLength={5} className="form-control"  value={inputs.deviceCost}  onChange={changeVHandler}/>
                            </div>                            
                            <div className='col-md-6 col-lg-2 form-group'>
                            Stock <span style={{color:"red"}}>&nbsp;*</span>
                            <input name="devicestock"  type="text"  maxLength={5} className="form-control"  value={devicestock} />                             
                           </div>
                            <div className='col-md-6 col-lg-1 form-group'>
                            Quantity 
                            <br/>
                            <input name="quantity"  type="text"  disabled={true} className="form-control"  value={quantity}  /> 
                            </div>                            
                            <div className='col-md-12 col-lg-12 form-group' style={{ "padding-top":"27px"}}>
                            <center><button className="btn btn-primary2" onClick={() => AddSaleDetails()}>Add</button>   </center>
                            </div>
  </div>
  <div style={{ height: "300px", display: cDisplay }} >  
  <div className='row'>  
  <div class="col-sm-2 col-lg-2"  style={{ textAlign:"right"}} ><b> Search by IMEI/SIM No :</b></div>   
  <div class="col-sm-4 col-lg-3"> <input type="text" class="form-control" tabindex="1" id="txtImeiNo" placeholder="IMEI NUMBER"   maxlength="20" value={sImeiNo} onChange={SImeiNochangeHandler}/>
  </div>
  <div class="col-sm-4 col-lg-3"> <input type="text" class="form-control" tabindex="2" id="txtSimNo" placeholder="SIM NUMBER"  maxlength="13" value={sSimNo} onChange={SSimNochangeHandler}/>
  </div>    
  <div class="col-sm-4 col-lg-3">
  <button type="button" class="btn btn-primary2 mt-20" tabindex="3" id="btnSearchNew" onClick={FilterGrid} >Search</button>
  <button type="button" class="btn btn-secondary mt-20" id="btnResetNew" tabindex="4" onClick={ResetList}>Reset
  </button></div>
      </div>            
            <div className="row" style={{ padding:"20px", height: "222px", overflowY: "auto" }} >
                
            <table id="example" class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
            <thead>
            <tr>
                    <th style={{ textAlign: "center"}} width="5%">Select</th>
                    <th style={{ textAlign: "center"}} width="10%">Device ID</th>
                    <th style={{ textAlign: "center"}} width="35%">Name</th>
                    <th style={{ textAlign: "center"}} width="20%">IMEI#</th>
                    <th style={{ textAlign: "center"}} width="20%">SIM#</th>
                    <th style={{ textAlign: "center"}} width="10%">Price</th>
                                      
            </tr>
            </thead>
            <tbody>
                {saleFDeviceData.map(item => (                    
                <tr key={item.id}>
                  <td style={{ textAlign:"center"}}>  
                  <input  className="form-check-input"  type="checkbox" name={'checkbox'+ rc}  value={item.imeiNumber}  id={'checkbox'+ rc}  onChange={ handleChange } />  </td> 
                  <td style={{ textAlign: "center"}}>{item.id}</td>
                  <td>{item.deviceName}</td>
                  <td style={{ textAlign: "center"}}>{item.imeiNumber}</td>
                  <td style={{ textAlign: "center"}}>{item.mobileNumber}</td>
                  <td style={{ textAlign: "center"}}>{inputs.deviceCost}</td>
                  <td style={{"display":"none"}}>{rc++}</td>     
                </tr>                 
                    ))}                
            </tbody>
            </table>
            </div>
            </div>
            <div className='row' style={{ display: cDisplay }}>
                <table>
                    <tr>
                        <td style={{ width:"50%" }}></td>
                        <td style={{ width:"20%" }}>Total Amount</td>
                        <td style={{ width:"10%" }}></td>
                        <td style={{ width:"17%" }}> <input name="totAmount"  type="text"  maxLength={10} className="form-control" style={{textAlign:"right"}}  value={ totAmount.toFixed(2) }  onChange={changeVHandler}/></td>
                        <td style={{ width:"3%" }}></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Discount</td>
                        <td></td>
                        <td> <input name="ddiscount"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={discountVal}  onChange={changeVHandler}/></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td >Installation Charge</td>
                        <td></td>
                        <td> <input name="installationcharge"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={insChargeVal}  onChange={changeVHandler}/></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>CGST%</td>
                        <td>
                            <select className="form-control" name="cgst"   style={{ "backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px", "padding": "5px 5px"}} value={cGstPer} onChange={ ChangeCGST }  >
                            <option value={0}>Select</option> 
                            <option value={9}>9%</option>   
                            <option value={18}>18%</option>        
                            </select>
                        </td>
                        <td> <input name="cgst"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={cGstVal.toFixed(2)}  onChange={changeVHandler}/></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>SGST%</td>
                        <td> <select className="form-control" name="sgst"   style={{ "backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px", "padding": "5px 5px"}} value={sGstPer}  onChange={ ChangeSGST } >
                            <option value={0}>Select</option> 
                            <option value={9}>9%</option>   
                            <option value={18}>18%</option>           
                            </select> 
                        </td>
                        <td><input name="sgst"  type="text"  maxLength={5} className="form-control" style={{textAlign:"right"}} value={sGstVal.toFixed(2)}  onChange={changeVHandler} /></td>
                    </tr>
                    <tr>
                         <td></td>
                        <td>IGST%</td>
                        <td> <select className="form-control" name="igst"   style={{ "backgroundColor":"white", "float": "right","margin-right": "5px","height": "15px", "padding": "5px 5px"}} value={iGstPer}  onChange={ ChangeIGST }  >
                            <option value={0}>Select</option> 
                            <option value={9}>9%</option>   
                            <option value={18}>18%</option>              
                            </select></td>
                        <td> <input name="igst"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={iGstVal.toFixed(2)}  onChange={changeVHandler}/></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>Grand Total</td>
                        <td></td>
                        <td> <input name="gtotal"  type="text"  maxLength={5} className="form-control"  style={{textAlign:"right"}} value={ gTotalVal.toFixed(2) }  onChange={changeVHandler}/></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </table>
                </div>               
            <div class="modal-footer justify-content-right" style={{display: btnDisplay , "text-align": "center" }}>
                <button className="btn btn-primary2" onClick={() => SaleInsert()}>Save</button> 
            </div>                
            <ToastContainer position="bottom-right" autoClose={4000} theme="light"/> 
    </>
  );
};
  
export default AddSale;